import { render, staticRenderFns } from "./date-table.vue?vue&type=template&id=32ff6d89&scoped=true&"
import script from "./date-table.vue?vue&type=script&lang=js&"
export * from "./date-table.vue?vue&type=script&lang=js&"
import style0 from "./date-table.vue?vue&type=style&index=0&id=32ff6d89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ff6d89",
  null
  
)

export default component.exports